module.exports = __webpack_public_path__ + "img/calendar.52e5358a.png";